import { Swiper } from 'swiper'
import {
  Navigation,
  Pagination,
} from 'swiper/modules'

if ($('.js-scienceSlider').length > 0) {
  new Swiper('.js-scienceSlider', {
    modules: [Navigation, Pagination],
    spaceBetween: 5,
    lockClass: 'is-hidden',
    pagination: {
      el: '.js-scienceSliderPagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.js-scienceSliderNext',
      prevEl: '.js-scienceSliderPrev',
    },
    breakpoints: {
      768: {
        spaceBetween: 11,
      },
      1024: {
        spaceBetween: 20,
      },
    },
  })
}
